(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bc2-annonce"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('bc2-annonce')) return;
    class Bc2Annonce extends HTMLElement {
      connectedCallback() {
        this.messages = [...this.querySelectorAll('.bc2-annonce__message')];
        if (this.messages.length < 2) return;
        this.index = 0;
        this.pause = false;
        const suspendre = () => { this.pause = true; };
        const reprendre = () => { this.pause = false; };
        this.addEventListener('mouseenter', suspendre);
        this.addEventListener('mouseleave', reprendre);
        this.addEventListener('focusin', suspendre);
        this.addEventListener('focusout', reprendre);
        const prec = this.querySelector('[data-bc2-annonce-prec]');
        const suiv = this.querySelector('[data-bc2-annonce-suiv]');
        if (prec) prec.addEventListener('click', () => this.montrer(this.index - 1));
        if (suiv) suiv.addEventListener('click', () => this.montrer(this.index + 1));
        this.minuterie = setInterval(() => {
          if (!this.pause && !document.hidden) this.montrer(this.index + 1);
        }, Number(this.dataset.delai) || 5000);
      }
      disconnectedCallback() { clearInterval(this.minuterie); }
      montrer(i) {
        this.index = (i + this.messages.length) % this.messages.length;
        this.messages.forEach((m, j) => {
          const actif = j === this.index;
          m.classList.toggle('is-actif', actif);
          if (actif) m.removeAttribute('aria-hidden'); else m.setAttribute('aria-hidden', 'true');
        });
      }
    }
    customElements.define('bc2-annonce', Bc2Annonce);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bc2-createurs"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.bc2CreateursPret) return;
  window.bc2CreateursPret = true;
  // « Regarder la vidéo » : lance la vidéo de la section (sur place ou en fenêtre selon la taille)
  document.addEventListener('click', (e) => {
    const bouton = e.target.closest && e.target.closest('[data-bc2-regarder]');
    if (!bouton) return;
    const video = bouton.closest('.bc2-createurs')?.querySelector('bc2-video');
    if (!video) return;
    video.scrollIntoView({ behavior: 'smooth', block: 'center' });
    video.querySelector(':scope > button')?.click();
  });
  // Carte d'un créateur (mode onglets) : sa vidéo remplace la vidéo affichée, le cadre jaune le suit
  const choisir = (carte) => {
    const section = carte.closest('.bc2-createurs');
    const ancienne = section?.querySelector('bc2-video');
    if (!ancienne || carte.classList.contains('bc2-createurs__carte--avant')) return;
    const nouvelle = ancienne.cloneNode(true);
    nouvelle.querySelectorAll('iframe').forEach((f) => f.remove());
    nouvelle.classList.remove('bc2-video--lecture', 'bc2-video--vide');
    nouvelle.dataset.video = carte.dataset.video;
    nouvelle.dataset.titre = carte.dataset.titre || '';
    const img = nouvelle.querySelector(':scope > img');
    if (img && carte.dataset.couverture) { img.removeAttribute('srcset'); img.src = carte.dataset.couverture; }
    const bouton = nouvelle.querySelector(':scope > button');
    if (bouton) { bouton.disabled = false; bouton.style.display = ''; }
    ancienne.replaceWith(nouvelle);
    section.querySelectorAll('[data-bc2-createur]').forEach((c) => {
      const actif = c === carte;
      c.classList.toggle('bc2-createurs__carte--avant', actif);
      c.setAttribute('aria-pressed', String(actif));
    });
  };
  document.addEventListener('click', (e) => { const c = e.target.closest && e.target.closest('[data-bc2-createur]'); if (c) choisir(c); });
  document.addEventListener('keydown', (e) => { if (e.key !== 'Enter' && e.key !== ' ') return; const c = e.target.closest && e.target.closest('[data-bc2-createur]'); if (c) { e.preventDefault(); choisir(c); } });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bc2-menu"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__bc2Menu) return;
    window.__bc2Menu = true;

    /* ---------- Menu qui revient quand on remonte ---------- */
    const SEUIL_REMONTEE = 10;
    const SEUIL_DESCENTE = 4;
    const initMenu = () => {
      const menu = document.querySelector('[data-bc2-menu]');
      if (!menu) return;
      const section = menu.closest('.shopify-section') || menu.parentElement;
      const wrapper = document.querySelector('.page-wrapper');
      /* Desktop Horizon : la page défile dans .page-wrapper ; mobile : dans le document. */
      const defileur = () => (wrapper && wrapper.scrollHeight > wrapper.clientHeight + 1 && /(auto|scroll)/.test(getComputedStyle(wrapper).overflowY) ? wrapper : document.scrollingElement || document.documentElement);
      let el = defileur();
      let dernier = el.scrollTop;
      let cumul = 0;
      let verrou = false;
      let finVerrou = 0;
      let haut = 0;

      const mesurer = () => {
        el = defileur();
        const h = menu.offsetHeight;
        section.style.setProperty('--bc2-menu-h', `${h}px`);
        /* Position naturelle du bas du menu dans le contenu défilé. */
        const r = section.getBoundingClientRect();
        const base = el === document.scrollingElement || el === document.documentElement ? 0 : el.getBoundingClientRect().top;
        haut = r.top - base + el.scrollTop;
        /* Largeur utile (sans la barre de défilement de .page-wrapper). */
        const zone = el === wrapper ? wrapper.getBoundingClientRect() : null;
        menu.style.setProperty('--bc2-menu-x', zone ? `${zone.left}px` : '0px');
        menu.style.setProperty('--bc2-menu-w', `${el.clientWidth}px`);
      };

      const montrer = (oui) => menu.classList.toggle('is-visible', oui);
      const detacher = (oui) => {
        if (oui === menu.classList.contains('is-detache')) return;
        menu.classList.toggle('is-detache', oui);
        if (oui) {
          menu.classList.remove('is-visible', 'is-anime');
          /* Animation activée seulement après le passage en fixe : pas de glissement parasite. */
          requestAnimationFrame(() => requestAnimationFrame(() => menu.classList.add('is-anime')));
        } else {
          menu.classList.remove('is-visible', 'is-anime');
        }
      };

      const surDefilement = () => {
        const y = Math.max(0, el.scrollTop);
        const delta = y - dernier;
        dernier = y;
        if (verrou) {
          clearTimeout(finVerrou);
          finVerrou = setTimeout(() => { verrou = false; cumul = 0; }, 180);
        }
        /* Tout en haut : le menu est à sa place, dans le flux. */
        if (y <= haut) { detacher(false); cumul = 0; return; }
        const hMenu = menu.offsetHeight;
        /* Encore en partie à sa place et pas affiché en fixe : on le laisse dans le flux. */
        if (y < haut + hMenu && !menu.classList.contains('is-visible')) { detacher(false); return; }
        if (!menu.classList.contains('is-detache')) detacher(true);
        if (verrou) { montrer(false); return; }
        if (delta < 0) {
          cumul = cumul > 0 ? delta : cumul + delta;
          if (-cumul > SEUIL_REMONTEE) montrer(true);
        } else if (delta > 0) {
          cumul = cumul < 0 ? delta : cumul + delta;
          if (cumul > SEUIL_DESCENTE) montrer(false);
        }
      };

      /* Les événements de défilement ne remontent pas : écoute en capture sur le
         document, filtrée sur le défileur de la page (pas les carrousels). */
      document.addEventListener('scroll', (e) => {
        const cible = e.target === document ? document.scrollingElement : e.target;
        if (cible !== el) {
          if (cible === wrapper || cible === document.scrollingElement) { mesurer(); dernier = el.scrollTop; }
          else return;
        }
        surDefilement();
      }, { capture: true, passive: true });

      /* Clic sur une ancre de la page : défilement programmé, menu masqué jusqu'à l'arrêt. */
      document.addEventListener('click', (e) => {
        const a = e.target.closest && e.target.closest('a[href*="#"]');
        if (!a) return;
        const url = new URL(a.href, location.href);
        if (url.pathname !== location.pathname || !url.hash || url.hash === '#') return;
        let cible = null;
        try { cible = document.getElementById(decodeURIComponent(url.hash.slice(1))); } catch (err) { cible = null; }
        if (!cible) return;
        verrou = true;
        montrer(false);
        clearTimeout(finVerrou);
        finVerrou = setTimeout(() => { verrou = false; cumul = 0; }, 1200);
      });

      mesurer();
      if ('ResizeObserver' in window) new ResizeObserver(mesurer).observe(menu);
      window.addEventListener('resize', () => { mesurer(); surDefilement(); }, { passive: true });
      surDefilement();
    };

    /* Ancre absente de la page courante (panier, page de règlement…) : on renvoie
       vers la même ancre sur l'accueil. */
    const corrigerAncres = () => {
      document.querySelectorAll('.bc2-menu a[href^="#"]').forEach((a) => {
        const id = a.getAttribute('href').slice(1);
        if (id && !document.getElementById(id)) a.setAttribute('href', `${window.Shopify?.routes?.root || '/'}#${id}`);
      });
    };
    const demarrer = () => { corrigerAncres(); initMenu(); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
    else demarrer();

    const afficher = (n) => {
      if (typeof n !== 'number' || Number.isNaN(n)) return;
      document.querySelectorAll('[data-bc2-panier-compte]').forEach((el) => { el.textContent = String(n); });
    };
    let requete = null;
    const relire = () => {
      if (requete) requete.abort();
      requete = new AbortController();
      fetch('/cart.js', { headers: { Accept: 'application/json' }, signal: requete.signal })
        .then((r) => (r.ok ? r.json() : null))
        .then((panier) => { if (panier) afficher(panier.item_count); })
        .catch(() => {});
    };
    const surMaj = (e) => {
      const d = e && e.detail;
      if (d && typeof d.item_count === 'number') afficher(d.item_count);
      if (e && e.promise && typeof e.promise.then === 'function') {
        e.promise.then(relire, relire);
      } else {
        relire();
      }
    };
    ['shopify:cart:lines-update', 'cart:update', 'bc2:panier'].forEach((nom) => document.addEventListener(nom, surMaj));
    window.addEventListener('pageshow', (e) => { if (e.persisted) relire(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bc2-packs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('bc2-packs')) return;
    const DUREE = 280;
    const reduit = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function conteneurDefilant(el) {
      for (let p = el.parentElement; p && p !== document.body; p = p.parentElement) {
        const o = getComputedStyle(p).overflowY;
        if ((o === 'auto' || o === 'scroll') && p.scrollHeight > p.clientHeight) return p;
      }
      return document.scrollingElement || document.documentElement;
    }

    class Bc2Packs extends HTMLElement {
      connectedCallback() {
        if (this.dataset.pret) return;
        this.dataset.pret = '1';
        this.addEventListener('click', (e) => {
          const ajout = e.target.closest('.bc2-packs__ajouter');
          if (ajout) { this.ajouter(ajout); return; }
          const carte = e.target.closest('.bc2-packs__carte');
          if (!carte || carte.hasAttribute('data-ouvert') || e.target.closest('a')) return;
          this.ouvrir(carte, true, e.detail === 0);
        });
        this.addEventListener('shopify:block:select', (e) => {
          const carte = e.target.closest && e.target.closest('.bc2-packs__carte');
          if (carte) this.ouvrir(carte, false);
        });
      }

      get cartes() { return [...this.querySelectorAll(':scope > .bc2-packs__carte')]; }

      ouvrir(carte, parClic, auClavier = false) {
        if (carte.hasAttribute('data-ouvert')) return;
        const cartes = this.cartes;
        const anime = !reduit();
        const avant = cartes.map((c) => c.getBoundingClientRect().height);
        const haut0 = carte.getBoundingClientRect().top;
        // Desktop : la colonne élargie suit le pack ouvert. On mesure l'état final sans
        // transition, puis on repart des colonnes d'avant pour animer le passage.
        const colsAvant = getComputedStyle(this).gridTemplateColumns;
        this.classList.add('sans-transition');

        cartes.forEach((c) => {
          const actif = c === carte;
          c.toggleAttribute('data-ouvert', actif);
          c.classList.toggle('bc2-carte--jeu', !actif);
          const bouton = c.querySelector('.bc2-packs__choisir');
          if (bouton) bouton.setAttribute('aria-expanded', String(actif));
          const detail = c.querySelector('.bc2-packs__detail');
          if (detail) detail.hidden = !actif;
          const erreur = c.querySelector('.bc2-packs__erreur');
          if (erreur) erreur.hidden = true;
        });
        this.remplir(carte);
        if (parClic) this.suivreKlaviyo(carte);

        const defileur = conteneurDefilant(this);
        // Garde le pack cliqué à la même place à l'écran pendant que l'autre se referme
        const epingle = parClic ? Math.max(haut0, 90) : null;
        const suivre = () => {
          if (epingle == null) return;
          const d = carte.getBoundingClientRect().top - epingle;
          // « instant » : le thème met scroll-behavior: smooth sur html, qui ferait s'empiler les corrections
          if (Math.abs(d) > 0.5) defileur.scrollTo({ top: defileur.scrollTop + d, behavior: 'instant' });
        };

        if (anime) {
          const apres = cartes.map((c) => c.getBoundingClientRect().height);
          this.style.gridTemplateColumns = colsAvant;
          cartes.forEach((c, i) => {
            if (Math.abs(avant[i] - apres[i]) < 1) return;
            c.classList.add('est-anime');
            c.style.height = avant[i] + 'px';
          });
          void this.offsetHeight;
          this.classList.remove('sans-transition');
          void this.offsetHeight;
          this.style.gridTemplateColumns = '';
          cartes.forEach((c, i) => { if (c.classList.contains('est-anime')) c.style.height = apres[i] + 'px'; });
          const debut = performance.now();
          const boucle = (t) => {
            suivre();
            if (t - debut < DUREE + 40) requestAnimationFrame(boucle);
            else this.finir(carte, parClic);
          };
          requestAnimationFrame(boucle);
        } else {
          this.classList.remove('sans-transition');
          suivre();
          this.finir(carte, parClic);
        }
        if (parClic && auClavier) {
          const bouton = carte.querySelector('.bc2-packs__ajouter');
          if (bouton && !bouton.disabled) bouton.focus({ preventScroll: true });
        }
      }

      // Klaviyo : « Viewed Product » quand le visiteur choisit un pack (il n'y a
      // pas de fiche produit, c'est l'équivalent de la vue produit). La file
      // window.klaviyo est lue par le script Klaviyo dès qu'il est chargé.
      suivreKlaviyo(carte) {
        let item = null;
        try { item = JSON.parse(carte.dataset.klaviyo || 'null'); } catch (_) {}
        if (!item || carte.dataset.klaviyoVu) return;
        carte.dataset.klaviyoVu = "1";
        window.klaviyo = window.klaviyo || [];
        window.klaviyo.push(['track', 'Viewed Product', item]);
      }

      // Jauges d'énergie du pack ouvert : les points pleins se rallument un à un (60 ms d'écart)
      remplir(carte) {
        this.arreterRemplissage();
        if (reduit()) return;
        carte.querySelectorAll('.bc2-packs__jauge').forEach((jauge) => {
          const points = [...jauge.querySelectorAll('.bc2-energie__point.is-plein')];
          points.forEach((p) => {
            p.style.transition = 'none';
            p.classList.remove('is-plein', 'est-pop');
            p.dataset.aRemplir = '';
          });
          void jauge.offsetWidth;
          points.forEach((p, i) => {
            p.style.transition = '';
            this.minuteurs.push(setTimeout(() => {
              p.classList.add('is-plein', 'est-pop');
              delete p.dataset.aRemplir;
            }, 120 + i * 60));
          });
        });
      }

      arreterRemplissage() {
        (this.minuteurs || []).forEach(clearTimeout);
        this.minuteurs = [];
        this.querySelectorAll('[data-a-remplir]').forEach((p) => {
          p.classList.add('is-plein');
          delete p.dataset.aRemplir;
        });
      }

      finir(carte, parClic) {
        this.cartes.forEach((c) => { c.classList.remove('est-anime'); c.style.height = ''; });
        if (!parClic) { carte.scrollIntoView({ behavior: reduit() ? 'auto' : 'smooth', block: 'nearest' }); return; }
        // Pack ouvert trop bas : on le remonte doucement pour montrer son détail
        const r = carte.getBoundingClientRect();
        if (r.top < 70 || r.top > window.innerHeight * 0.55) {
          carte.scrollIntoView({ behavior: reduit() ? 'auto' : 'smooth', block: 'start' });
        }
      }

      async ajouter(bouton) {
        if (bouton.disabled || bouton.getAttribute('aria-busy') === 'true') return;
        const id = Number(bouton.dataset.variante);
        if (!id) return;
        const carte = bouton.closest('.bc2-packs__carte');
        // Pack ouvert par défaut ajouté sans clic préalable : c'est aussi un choix
        this.suivreKlaviyo(carte);
        const erreur = carte.querySelector('.bc2-packs__erreur');
        const texte = bouton.querySelector('.bc2-packs__ajouter-texte');
        const initial = texte.textContent;
        erreur.hidden = true;
        bouton.setAttribute('aria-busy', 'true');
        bouton.disabled = true;
        texte.textContent = this.dataset.libelleAjout || 'Ajout…';
        try {
          const r = await fetch(this.dataset.urlAjout, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id, quantity: 1 }] }),
          });
          const donnees = await r.json().catch(() => ({}));
          if (!r.ok) throw new Error(donnees.description || donnees.message || '');
          let nb = null;
          try {
            const panier = await fetch(this.dataset.urlPanierJs, { headers: { Accept: 'application/json' } }).then((x) => x.json());
            nb = panier.item_count;
          } catch (_) {}
          document.dispatchEvent(new CustomEvent('bc2:panier', { detail: { item_count: nb } }));
          window.location.href = this.dataset.apres === 'panier' ? this.dataset.urlPanier : this.dataset.urlCheckout;
        } catch (e) {
          erreur.textContent = (e && e.message) || this.dataset.erreur || "L'ajout au panier n'a pas marché. Réessaie dans un instant.";
          erreur.hidden = false;
          bouton.disabled = false;
          bouton.removeAttribute('aria-busy');
          texte.textContent = initial;
        }
      }
    }
    customElements.define('bc2-packs', Bc2Packs);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bc2-paliers"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('bc2-paliers')) return;
    class Bc2Paliers extends HTMLElement {
      connectedCallback() {
        if (window.BC2) this.maj();
        else document.addEventListener('DOMContentLoaded', () => this.maj(), { once: true });
      }
      maj() {
        if (!window.BC2) return;
        const nf = new Intl.NumberFormat('fr-FR');
        window.BC2.tiers().then((r) => {
          if (!r || typeof r.total !== 'number' || !this.isConnected) return;
          // Espaces fines du format français remplacées par des insécables simples
          const fmt = (n) => nf.format(n).replace(/[  ]/g, ' ');
          const cartes = [...this.querySelectorAll('[data-bc2-palier]')];
          cartes.forEach((c) => {
            if (c.dataset.etat !== 'auto') return;
            // Seuils saisis côté serveur (config/club.json) : le serveur tient la
            // liste des paliers débloqués, définitifs (unlocked_ranks). Sinon, le
            // seuil de l'éditeur comparé au total.
            const seuilsSrv = Array.isArray(r.thresholds) && r.thresholds.some((n) => typeof n === 'number');
            const ouvert = seuilsSrv
              ? Array.isArray(r.unlocked_ranks) && r.unlocked_ranks.includes(Number(c.dataset.rang))
              : Number(c.dataset.seuil) > 0 && r.total >= Number(c.dataset.seuil);
            c.classList.toggle('bc2-paliers__carte--ouvert', ouvert);
          });
          const cpt = this.querySelector('[data-bc2-compteur]');
          if (cpt) {
            const modele = cpt.dataset.modele || '[total] commandes';
            cpt.querySelector('[data-bc2-compteur-texte]').textContent = modele.replace('[total]', fmt(r.total));
            cpt.hidden = false;
          }
        });
      }
    }
    customElements.define('bc2-paliers', Bc2Paliers);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bc2-panier"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.bc2PanierPret) return;
  window.bc2PanierPret = true;
  // Quantité et « Retirer » : mise à jour du panier puis rechargement (montants recalculés par Shopify)
  document.addEventListener('click', async (e) => {
    const bouton = e.target.closest && e.target.closest('.bc2-panier [data-bc2-qte]');
    if (!bouton) return;
    const article = bouton.closest('[data-cle]');
    if (!article || article.getAttribute('aria-busy') === 'true') return;
    article.setAttribute('aria-busy', 'true');
    try {
      await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: article.dataset.cle, quantity: Math.max(0, Number(bouton.dataset.bc2Qte) || 0) }),
      });
    } finally {
      window.location.reload();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bc2-sticky"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('bc2-sticky')) return;
    class Bc2Sticky extends HTMLElement {
      connectedCallback() {
        const cible = this.dataset.cible || '';
        const id = cible.includes('#') ? cible.split('#')[1] : '';
        this.packs = id ? document.getElementById(id) : null;
        /* Lien vers une ancre absente de cette page : la barre n'a rien à proposer. */
        if (id && !this.packs && (cible.startsWith('#') || new URL(cible, location.href).pathname === location.pathname)) return;

        this.barre = this.querySelector('[data-bc2-sticky-barre]');
        this.hidden = false;
        this.ctaPasse = false;
        this.packsVisible = false;

        new ResizeObserver(() => {
          this.style.setProperty('--bc2-sticky-h', `${this.barre.offsetHeight}px`);
        }).observe(this.barre);

        /* Position relue au défilement (et non par IntersectionObserver) : un saut
           direct sous le hero (ancre, défilement rapide, rechargement) est aussi vu
           quand le bouton du hero est déjà sous la ligne de flottaison au chargement. */
        this.cta = document.querySelector('[data-bc2-hero-cta]');
        this.verifier = () => {
          this.raf = 0;
          const vh = window.innerHeight;
          this.ctaPasse = this.cta ? this.cta.getBoundingClientRect().bottom < 0 : true;
          if (this.packs) {
            const r = this.packs.getBoundingClientRect();
            this.packsVisible = r.top < vh * 0.7 && r.bottom > 0;
          }
          this.maj();
        };
        this.planifier = () => { if (!this.raf) this.raf = requestAnimationFrame(this.verifier); };
        document.addEventListener('scroll', this.planifier, { capture: true, passive: true });
        window.addEventListener('resize', this.planifier, { passive: true });
        this.verifier();
      }
      disconnectedCallback() {
        if (this.planifier) {
          document.removeEventListener('scroll', this.planifier, { capture: true });
          window.removeEventListener('resize', this.planifier);
        }
      }
      maj() {
        if (!this.barre) return;
        const visible = this.ctaPasse && !this.packsVisible;
        this.classList.toggle('is-visible', visible);
        this.barre.inert = !visible;
      }
    }
    customElements.define('bc2-sticky', Bc2Sticky);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bc2-zoom"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('bc2-zoom')) return;
    const reduit = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    class Bc2Zoom extends HTMLElement {
      connectedCallback() {
        this.panneaux = [...this.querySelectorAll('[role="tabpanel"]')];
        this.panneaux.forEach((pan) => this.brancherPanneau(pan));
        this.prec = this.querySelector('[data-bc2-prec]');
        this.suiv = this.querySelector('[data-bc2-suiv]');
        this.prec?.addEventListener('click', () => this.pas(-1));
        this.suiv?.addEventListener('click', () => this.pas(1));
        this.addEventListener('bc2:onglet', () => this.majFleches());
        this.brancherVideo();
        this.majFleches();
      }

      defileActif() {
        const pan = this.panneaux.find((p) => !p.hidden) || this.panneaux[0];
        return pan ? pan.querySelector('[data-bc2-defile]') : null;
      }

      pasCarte(defile) {
        const a = defile.children[0];
        const b = defile.children[1];
        if (!a) return defile.clientWidth;
        return b ? b.offsetLeft - a.offsetLeft : a.offsetWidth;
      }

      pas(sens) {
        const d = this.defileActif();
        if (!d) return;
        d.scrollBy({ left: sens * this.pasCarte(d), behavior: reduit() ? 'auto' : 'smooth' });
      }

      indexActif(d) {
        const n = d.children.length;
        if (d.scrollLeft + d.clientWidth >= d.scrollWidth - 4) return n - 1;
        return Math.min(n - 1, Math.max(0, Math.round(d.scrollLeft / this.pasCarte(d))));
      }

      brancherPanneau(pan) {
        const d = pan.querySelector('[data-bc2-defile]');
        const points = [...pan.querySelectorAll('[data-bc2-points] button')];
        if (!d) return;
        let rafId = 0;
        const maj = () => {
          rafId = 0;
          const i = this.indexActif(d);
          points.forEach((p, j) => (j === i ? p.setAttribute('aria-current', 'true') : p.removeAttribute('aria-current')));
          this.majFleches();
        };
        d.addEventListener('scroll', () => { if (!rafId) rafId = requestAnimationFrame(maj); }, { passive: true });
        points.forEach((p, j) => p.addEventListener('click', () => {
          const cible = d.children[j];
          if (cible) d.scrollTo({ left: cible.offsetLeft - d.children[0].offsetLeft, behavior: reduit() ? 'auto' : 'smooth' });
        }));
      }

      majFleches() {
        const d = this.defileActif();
        if (!d || !this.prec) return;
        const max = d.scrollWidth - d.clientWidth;
        this.prec.disabled = d.scrollLeft <= 4;
        this.suiv.disabled = d.scrollLeft >= max - 4;
      }

      brancherVideo() {
        const dlg = this.querySelector('[data-bc2-dialogue]');
        const cadre = this.querySelector('[data-bc2-cadre]');
        if (!dlg || !cadre || typeof dlg.showModal !== 'function') return;
        const fermer = () => dlg.close();
        this.querySelector('[data-bc2-fermer]')?.addEventListener('click', fermer);
        dlg.addEventListener('click', (e) => { if (e.target === dlg) fermer(); });
        dlg.addEventListener('close', () => { cadre.innerHTML = ''; });
        this.querySelectorAll('[data-bc2-zoom-video]').forEach((lien) => {
          lien.addEventListener('click', (e) => {
            const id = window.BC2 && window.BC2.idYouTube(lien.getAttribute('href'));
            if (!id) return; // autre lien : ouverture normale dans un nouvel onglet
            e.preventDefault();
            const f = document.createElement('iframe');
            f.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0&playsinline=1`;
            f.title = lien.dataset.titre || 'Vidéo';
            f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
            f.allowFullscreen = true;
            cadre.appendChild(f);
            dlg.showModal();
          });
        });
      }
    }
    customElements.define('bc2-zoom', Bc2Zoom);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
